/**
 * Close 打开状态
 */
const CloseOpenIcon = ({ width = 18, height = 18, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path d="M3 11L3 13L10 13L11 12L10 11L3 11Z" fill="currentColor" />
      <path d="M21 11L21 13L14 13L13 12L14 11L21 11Z" fill="currentColor" />
    </svg>
  )
}

export default CloseOpenIcon
